/*
	Project : AddMustard
	Author(s) : David Charles
*/

//Dependencies
import React from 'react';
import ReactDOM from 'react-dom/client';
import reportWebVitals from './reportWebVitals';

//Components
import App from './App';

//Styles
import './index.scss'; 

//Render App
const root : ReactDOM.Root = ReactDOM.createRoot( document.getElementById('root') as HTMLElement );

root.render(
	<React.StrictMode>
		<App />
	</React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
